import HeaderMobile from "@/app/components/HeaderMobile";
import HeaderMobileMenu from "@/app/components/HeaderMobileMenu";

export default function HeaderContainer() {
    return (
        <div className="sticky top-0 z-50 bg-dark-04">
            <HeaderMobile/>
            <HeaderMobileMenu/>
        </div>
    );
}